import api from './api';

export const userService = {
  /**
   * Get all users and user types.
   */
  getAllUsers: async () => {
    const response = await api.get('/users');
    return response.data;
  },

  /**
   * Check if a username is available.
   */
  checkUsername: async (username) => {
    const response = await api.get(`/users/check-username/${encodeURIComponent(username)}`);
    return response.data;
  },

  /**
   * Get list of recently active usernames.
   */
  getUsernames: async () => {
    const response = await api.get(`/users/usernames`);
    return response.data;
  },

  /**
   * Get user by username.
   */
  getUser: async (username) => {
    const response = await api.get(`/users/${username}`);
    return response.data;
  },

  /**
   * Create a new user.
   */
  createUser: async (userData) => {
    const response = await api.post('/users', userData);
    return response.data;
  },

  /**
   * Update an existing user.
   */
  updateUser: async (id, userData) => {
    const response = await api.put(`/users/${id}`, userData);
    return response.data;
  },

  /**
   * Change a user's password.
   */
  changePassword: async (id, newPassword) => {
    const response = await api.put(`/users/${id}/password`, { newPassword });
    return response.data;
  },

  /**
   * Delete a user.
   */
  deleteUser: async (id) => {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  },
};